export const DEFAULT_NON_DESKTOP_BROWSER = 834

export const DEFAULT_MOBILE_BROWSER = 480

export const MINI_IPAD = 744



